export default __webpack_public_path__ + "static/media/profile.e91b95be.svg";